<template>
  <gj-modal
      size="1300_auto"
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="loading"
  >
    <template #header>
      标记推广订单
    </template>
    <template #content>
      <gj-table
          :data="data"
          :columns="columns"
          :show-pagination="false"
          :adaptHeight="false"
          :height="440"
      >
        <template v-slot:msku="{ row }">
          <gj-tooltip :text-line="1" :content="row.title">
            {{row.title}}
          </gj-tooltip>
          <el-row>
            <el-col :span="11">
              <el-row>
                <el-col :span="18">
                  <a :href="row.asinUrl" target="_blank">
                    {{row.asin}}
                  </a>
                </el-col>
                <el-col :span="4" v-if="row.asin">
                      <span v-copy="row.asin"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="13">
              <el-row>
                <el-col :span="20">
                  <gj-tooltip :text-line="1" :content="row.msku">
                    {{row.msku || '-'}}
                  </gj-tooltip>
                </el-col>
                <el-col :span="4" v-if="row.msku">
                      <span v-copy="row.msku"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </template>
        <template v-slot:promoteFeePrincipal="{row}">
          <gj-select-input
              :width="['80px', '80px']"
              :placeholder="['币种', '请输入']"
              :search="false"
              :options="currencyOption"
              :value="row.promoteFeePrincipal"
          >
          </gj-select-input>
        </template>
        <template v-slot:promoteFeeCommission="{row}">
          <gj-select-input
              :width="['80px', '80px']"
              :placeholder="['币种', '请输入']"
              :search="false"
              :options="currencyOption"
              :value="row.promoteFeeCommission"
          >
          </gj-select-input>
        </template>
        <template v-slot:memo="{row}">
          <gj-input
              v-model="row.memo"
              placeholder="请输入备注"
              width="100%"
          >
          </gj-input>
        </template>
      </gj-table>
    </template>
    <template #footer>
      <gj-button @click.stop="cancel">取消</gj-button>
      <gj-button type="primary" @click.stop="confirm" :loading="loading">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {batchMarkPromoteOrder} from "../../../../../api/sale";
  import {currencysOption} from "../../../../../utils/options";

  export default {
    name: "sale-order-mark-promote",
    mixins: [modalMixIn],
    props: {
      item: {
        type: Array,
        default: () => []
      },
    },
    created() {
      if (this.item && this.item.length > 0) {
        this.item.forEach(val => {
          val.items.forEach(v => {
            this.data.push({
              fid: v.id,
              marketId: val.marketId,
              orderId: val.orderId,
              promoteFeePrincipal: {},
              promoteFeeCommission: {},
              salePrice: v.salePrice,
              currencySymbol: val.currencySymbol,
              // commission: null,
              // commissionCurrency: null,
              // principal: null,
              // principalCurrency: null,
              memo: null,
              title: v.title,
              asin: v.asin,
              asinUrl: v.asinUrl,
              msku: v.msku,
              imageUrl: v.imageUrl,
              quantityOrdered: v.quantityOrdered,
            })
          })
        })
      }
    },
    data() {
      return {
        data: [
          // {
          //     order: 1111-111-11111,
          //     currency: 'USD',
          //     promoteFee: '',
          //     promoteFeePrincipal: {},
          //     promoteFeeCommission: {},
          //     memo: '',
          // }
        ],
        columns: [
          {id: 'orderId', header: '订单编号', field: 'orderId', minWidth: '170px', default: true},
          {id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
          {id: 'msku', header: '商品标题/ASIN/MSKU', field: 'slot:msku', minWidth: '250px', default: true},
          {id: 'quantityOrdered', header: '数量', field: 'quantityOrdered', minWidth: '50px', default: true},
          {
            id: 'salePrice',
            header: '商品售价',
            field: 'salePrice',
            minWidth: '120px',
            default: true,
            prefix: 'currencySymbol'
          },
          {
            id: 'promoteFeePrincipal',
            header: '推广订单本金',
            field: 'slot:promoteFeePrincipal',
            minWidth: '180px',
            default: true
          },
          {
            id: 'promoteFeeCommission',
            header: '推广订单佣金',
            field: 'slot:promoteFeeCommission',
            minWidth: '180px',
            default: true
          },
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '140px', default: true},
        ],
        loading: false,
        currencyOption: currencysOption.map(v => ({id: v.id, text: v.id})),
      }
    },
    methods: {
      confirm() {
        let checkMsg = null;
        const params = this.data.map(v => {
          const param = {
            fid: v.fid,
            marketId: v.marketId,
            orderId: v.orderId,
            commission: v.promoteFeeCommission.value ? v.promoteFeeCommission.value : null,
            commissionCurrency: v.promoteFeeCommission.key ? v.promoteFeeCommission.key : null,
            principal: v.promoteFeePrincipal.value ? v.promoteFeePrincipal.value : null,
            principalCurrency: v.promoteFeePrincipal.key ? v.promoteFeePrincipal.key : null,
          };
          if ((param.commission === null && param.commissionCurrency !== null)
            || (param.commission !== null && param.commissionCurrency === null)
            || (param.principal === null && param.principalCurrency !== null)
            || (param.principal !== null && param.principalCurrency === null)
          ) {
            checkMsg = '录入费用时币种与金额必须同时存在';
          }
          return param
        });
        if (checkMsg !== null) {
          this.$gjMessage.error(checkMsg);
          return;
        }
        this.loading = true;
        batchMarkPromoteOrder({testOrderItems: params})
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$emit('create');
          }).complete(() => this.loading = false)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
